import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Inject,
    ViewChild
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { FormBuilder } from "@angular/forms";
import { AppService } from "../../../services/app.service";
import { MatStepper } from "@angular/material";
import { Order } from "../../../models/order.model";
import { OrderService } from "../../../services/order.service";
import { DeliveryDetailComponent } from "./delivery-detail/delivery-detail.component";
import { PaymentDetailComponent } from "./payment-detail/payment-detail.component";
import { zMultiUserHandler } from '../../../models/user.model';
import { SystemDataService } from '../../../services/systemdata.service';

@Component({
    selector: "app-order-edit-form",
    templateUrl: "./order-edit-form.component.html",
    styleUrls: ["./order-edit-form.component.scss"]
})
export class OrderEditFormComponent implements OnInit {
    @Output() closeDialogue = new EventEmitter();
    translations: any;

    multiUserHandler = new zMultiUserHandler();
    disableSave: Boolean = false;
    showSaveButton : Boolean = true;
constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public viewMode: any,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public appService: AppService,
    public dialogRef: MatDialogRef<OrderEditFormComponent>,
    public order: Order,
    private orderService: OrderService,
    public systemDataService: SystemDataService
) {
    debugger;
    this.setPageTranslations();
    this.order = data;
    this.showSaveButton = !(sessionStorage.getItem("ViewMode") == 'true');
}
ngOnInit() {
    this.appService.showLoading();

}
apiFaillure(error): void {
    this.appService.showDialogue("Error", this.translations[error]);
}
close() {
    this.dialogRef.close();
}
save(): void {
    
    if(this.order.Id > 0){
        this.appService.showLoading();
        this.multiUserHandler.RecordId = this.order.Id;
        this.multiUserHandler.TableName = "tOrder";
        this.systemDataService.multiuserhandler(JSON.stringify(this.multiUserHandler)).subscribe(
            res => this.multiUserHandlerSuccess(res),
            error => this.apiFaillure(error)
        );
    }
    else{
        this.saveOrderDetails();
    }
}

canChangeStatusToDelivered(status){
    if(this.order.Status == 152){ 
      if((this.order.D_ShipDate != undefined && this.order.D_ShipDate.toString() != "") && 
        (this.order.D_LicensePlate != undefined && this.order.D_LicensePlate != "") && 
          (this.order.D_T2No != undefined && this.order.D_T2No != "") && 
            (this.order.D_ReceiveDate != undefined && this.order.D_ReceiveDate.toString() != "") && 
              (this.order.D_PlannedDate != undefined && this.order.D_PlannedDate.toString() != "") && 
                (this.order.D_ActualDate != undefined && this.order.D_ActualDate.toString() != "")){
        return true;              
      }else
        return false;
    }else
      return true;
  }

saveOrderDetails(): void{
    if(this.canChangeStatusToDelivered('abc')){
        this.order.RegistrationDate = this.appService.JSONDate(
        this.order.RegistrationDate
        );
        this.order.D_ShipDate = this.appService.JSONDate(this.order.D_ShipDate);
        this.order.D_ReceiveDate = this.appService.JSONDate(this.order.D_ReceiveDate);
        this.order.D_PlannedDate = this.appService.JSONDate(this.order.D_PlannedDate);
        this.order.D_ActualDate = this.appService.JSONDate(this.order.D_ActualDate);
        this.order.F_PaymentDate = this.appService.JSONDate(this.order.F_PaymentDate);

        //this.order.F_CODCAmount = Number(((Number(this.order.P_ActualPaid / 100)) *  Number(this.order.F_CODCost)).toFixed(2)).toString();
        //this.order.F_CODCAmount = Number(this.order.F_CODCAmount).toFixed(2).toString();

        this.appService.showLoading();
        this.orderService
        .save(JSON.stringify(this.order))
        .subscribe(
        res => this.saveOrderSuccess(res),
        error => this.apiFaillure(error)
        );
    }else{
        this.showOrderDeliveredStatusDialog(!this.canChangeStatusToDelivered('abc'));
    }
}

saveOrderSuccess(res): void {
    if (res.Status == 1) {
        if(typeof JSON.parse(res.Data)[0] != 'undefined')
        {
            this.order.Id = JSON.parse(res.Data)[0]["Ïd"];
            this.order.OrderNo = JSON.parse(res.Data)[0]["OrderNo"];
        }
        this.appService
            .showDialogue(
            this.translations["hdSuccess"],
            this.translations[res.Message]
        )
            .afterClosed()
            .subscribe(result => {
            if (result) {
                this.close();
            }
        });
    } else {
        this.apiFaillure(res.Message);
    }
    this.appService.hideLoading();
}

setPageTranslations() {
    this.translations = JSON.parse(sessionStorage.getItem("pageData"));
}
goBack(stepper: MatStepper) {
    stepper.previous();
}
goForward(stepper: MatStepper) {
    stepper.next();
}

showOrderDeliveredStatusDialog(flag){
    this.appService.showDialogue(this.translations.lblStatusDialogHeader, this.translations.msgStatusDialogContent, false).afterClosed().subscribe(result => {
        this.close();
    });
}

multiUserHandlerSuccess(res){
    this.appService.hideLoading();
    if(res.Status == 1){
        this.appService.showDialogue(this.translations.hdInfo, this.translations.msgOverwriteExistingDetails,true)
        .afterClosed().subscribe(result => {
            if(result){
                this.saveOrderDetails();
            }
            else{
                this.close();
            }
        });
    }
    else{
        this.saveOrderDetails();
    }
}

getLabel(){
    return this.order.InvoiceNo != undefined && this.order.C_Name != undefined ? " :: " + this.order.InvoiceNo.toString().toUpperCase() + ' >> ' + this.order.C_Name : "";
}
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/order-edit-form.component.ts